import Search         from "./components/Search";
import ColorPicker    from "./components/ColorPicker";
import SimpleCalendar from "./components/SimpleCalendar";

const routes = [
    {
        path: '/:dataset/calendar',
        component: SimpleCalendar,
        name: 'calendar',
        props: true
    },
    {path: '/:dataset/search', component: Search, name: 'search', props: true},
    {path: '/ColorPicker', component: ColorPicker, name: 'Color-Picker'},
];

export default routes;